import http from "../../../global/http"

export const getBundlePricing = async (orgId: string) => {
  try {
    const { data } = await http.get(`/shared/v1/org/${orgId}/payments/bundle/`)
    return data
  } catch (err) {
    return err
  }
}
